import Observer from "zen-observable"
import type {ZenObservable} from "zen-observable"
import AuthedStream from "@irati/auth/streams/auth"
import {Auth} from "../../types"
import ObserveWithPriority from "./ObserveWithPriority"

interface AuthLoggedIn {
  loggedInStream?: boolean
}

/**
 * This is only needed to check when a user logs out
 * @deprecated Do not consume directly, use via `useIsLoggedIn`
 */
export class LogInAuthStream {
  isLoggedIn?: boolean
  observers: ZenObservable.SubscriptionObserver<AuthLoggedIn>[] = []
  constructor() {
    new ObserveWithPriority<Auth>({streams: [AuthedStream], key: "user"}).subscribe((data) => {
      this.isLoggedIn = !!(data && data.user && data.business && data.productPermissions)

      this.observers.forEach((observer) => {
        observer.next({loggedInStream: this.isLoggedIn})
      })
    })
  }

  get stream() {
    return new Observer<AuthLoggedIn>((observer) => {
      this.observers.push(observer)

      return () => {
        this.observers = this.observers.filter((t) => t !== observer)
      }
    })
  }
}
